import { BlockQuote } from '@/components/Text/BlockQuote'

import { Link } from '@/components/Link/Link'
import { Text } from '@/components/Text/Text'

import { YoutubeEmbed } from './youtube-embed/youtube-embed'

import css from './quote-card.module.css'

export default {
    title: 'Others/Quote',
    component: QuoteCard,
}

export type QuoteCardProps = {
    author: string
    role?: string
    quoteText: string
    videoId?: string
    calloutLinkTitle?: string
    calloutLinkUrl?: string
    calloutLinkIcon?: 'arrow' | 'video' | 'external' | 'download'
}

function QuoteCard({
    author,
    role,
    quoteText,
    videoId,
    calloutLinkTitle,
    calloutLinkUrl,
    calloutLinkIcon = 'arrow',
}: QuoteCardProps) {
    return (
        <div className={css.quoteCard}>
            {quoteText && <BlockQuote size="quote-base">{quoteText}</BlockQuote>}
            <div className={css.author}>
                <div className={css.details}>
                    <Text tag="p" size="body-lg">
                        {author}
                    </Text>
                    {role && (
                        <Text className={css.role} tag="p" size="body-xs">
                            {role}
                        </Text>
                    )}
                </div>
                {calloutLinkTitle && (
                    <div className={css.callout}>
                        <Link icon={calloutLinkIcon} href={calloutLinkUrl}>
                            {calloutLinkTitle}
                        </Link>
                    </div>
                )}
            </div>
            {videoId && <YoutubeEmbed className={css.video} youtubeId={videoId} />}
        </div>
    )
}

export { QuoteCard }
